import { CurvePhase } from '@gong/curve-math';

export function PhaseBadge({ phase }: { phase: CurvePhase }) {
  return (
    <span className="phase" data-phase={phase}>
      <i />
      {phase}
    </span>
  );
}
